import React, { createContext, useContext, useMemo, useState } from "react";

/** Global filter: show all satellites, or restrict to LEO / GEO. */
export const SATELLITE_ALL = "ALL";
export const SATELLITE_LEO = "LEO";
export const SATELLITE_GEO = "GEO";

export const SatelliteContext = createContext(null);

export function SatelliteProvider({ children, defaultSatellite = SATELLITE_ALL }) {
  const [satellite, setSatellite] = useState(defaultSatellite);

  const value = useMemo(() => ({ satellite, setSatellite }), [satellite]);

  return <SatelliteContext.Provider value={value}>{children}</SatelliteContext.Provider>;
}

export function useSatellite() {
  const ctx = useContext(SatelliteContext);
  if (!ctx) throw new Error("useSatellite must be used within a SatelliteProvider");
  return ctx;
}

